const supabaseUrl = import.meta.env.VITE_SUPABASE_URL?.trim() ?? '';
const supabaseKey =
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY?.trim() ||
  import.meta.env.VITE_SUPABASE_ANON_KEY?.trim() ||
  '';

export const appConfig = {
  supabaseUrl,
  supabaseKey,
  supabaseConfigured: Boolean(supabaseUrl && supabaseKey),
  storeName: import.meta.env.VITE_STORE_NAME?.trim() || 'STOCK/ROOM',
  storeTagline:
    import.meta.env.VITE_STORE_TAGLINE?.trim() ||
    'Equipaciones, drops y pedidos sin fricción.',
  currency: import.meta.env.VITE_CURRENCY?.trim() || 'EUR',
  locale: import.meta.env.VITE_LOCALE?.trim() || 'es-ES',
};
